module.exports = __webpack_public_path__ + "img/Coupes_disabled.94c28849.svg";